import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from "../../store/settings/settingsSlice";
import style from "./wallet.module.css";
import swapIcon from '../../assets/images/arrange-square.svg'
import withdrawIcon from '../../assets/images/withdraw.svg'
import receiveIcon from '../../assets/images/receive.svg'
import info_icon from '../../assets/images/info_icon.svg'
import arrow_left from '../../assets/images/arrow-left.svg'
import bitcoinIcon from '../../assets/images/bitcoin.svg'
import ethIcon from "../../assets/images/ethereum-eth-logo.png";
import ltcIcon from "../../assets/images/litecoin-ltc-logo.svg";
import usdtIcon from "../../assets/images/tether-usdt-logo.svg";
import xrpIcon from "../../assets/images/xrp-xrp-logo.svg";
import dogeIcon from "../../assets/images/dogecoin-doge-logo.svg";
import trxIcon from "../../assets/images/tron-trx-logo.svg";
import bnbIcon from "../../assets/images/bnb-bnb-logo.svg";
import usdcIcon from "../../assets/images/usd-coin-usdc-logo.svg";
import solIcon from "../../assets/images/solana-sol-logo.svg";
import xlmIcon from "../../assets/images/stellar-xlm-logo.svg";
import spin_circle from '../../assets/images/Loader anim.png'
import successIcon from '../../assets/images/check-mark.svg'
import { useLocation } from "react-router-dom";
import { Eye, EyeSlash } from "iconsax-react";
import { ArrowDown2 } from "iconsax-react";
import { browserName } from "react-device-detect";
import Modal from '../modal/Modal';
import { useNavigate } from "react-router-dom";
import cogoToast from "cogo-toast";
import { getWalletBalance, fetchExchangeConfig,InitiateExchange } from "../../store/wallet/walletActions";
import { generateSwapQuotation, getUserCryptoTransactions, tradeCryptoToFiat, fiatToCrypto,} from "../../store/crypto/cryptoActions";
import { getCryptoCoins } from "../../store/settings/settingsActions";
import moment from "moment";


const coinIcons = {
  BTC: bitcoinIcon,
  ETH: ethIcon,
  LTC: ltcIcon,
  USDT: usdtIcon,
  XRP: xrpIcon,
  DOGE: dogeIcon,
  TRX: trxIcon,
  BNB: bnbIcon,
  USDC: usdcIcon,
  SOL: solIcon,
  XLM: xlmIcon,
};

const fiatAssetMeta = {
  NGN: {
    name: "Naira",
    symbol: "NGN",
    icon: "https://flagcdn.com/ng.svg",
    pricePrefix: "₦",
  },
  GHS: {
    name: "Ghana Cedis",
    symbol: "GHS",
    icon: "https://flagcdn.com/gh.svg",
    pricePrefix: "GH₵",
  },
  USD: {
    name: "US Dollar",
    symbol: "USD",
    icon: "https://flagcdn.com/us.svg",
    pricePrefix: "$",
  },
};

const FiatWalletPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    
    // ========== MODAL STATES ==========
       // ========== SWAP STATES ==========
    const [isInstantSwapOpen, setIsInstantSwapOpen] = useState(false);
    const [toCoin, setToCoin] = useState(null);
    const [swapAmount, setSwapAmount] = useState("");
    const [receiveAmount, setReceiveAmount] = useState("");
    const [openToSelect, setOpenToSelect] = useState(false);
    const [openFromSelect, setOpenFromSelect] = useState(false);
    const [swapType, setSwapType] = useState("FIAT_TO_CRYPTO");
    const [openSwapType, setOpenSwapType] = useState(false);
    const [swapTypeLabel, setSwapTypeLabel] = useState("Fiat to Crypto");
    const [isSwapInitiated, setIsSwapInitiated] = useState(false);
    const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);
    const [quotationError, setQuotationError] = useState("");
    const [currentRate, setCurrentRate] = useState("");
    const [currencyExchangeSettingsId, setCurrencyExchangeSettingsId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isSuccessModal, setSuccessModal] = useState(false);


    // ========== REDUX SELECTORS ==========
    const walletData = useSelector((state) => state.wallet.data);
    const exchangeConfig = useSelector((state) => state.wallet.exchangeConfig);

    // ========== URL PARAMS ==========
    const params = new URLSearchParams(location.search);
    const currency = params.get("currency")?.toUpperCase() || "USD";
    
    // ========== UI STATES ==========
    const [visible, setVisible] = useState(true);
    const [transactions, setTransactions] = useState([]);
    const [transactionsMeta, setTransactionsMeta] = useState({ page: 0, per_page: 15, count: 0 });
    const [txPage, setTxPage] = useState(0);
    const [txPerPage, setTxPerPage] = useState(15);
    const [isLoadingTransactions, setIsLoadingTransactions] = useState(false);

    // Find the fiat wallet for the currency
    const selectedWallet = walletData?.fiatWallets?.find(
        w => w.Currency?.code?.toUpperCase() === currency
    );

    const selectedFiat = selectedWallet ? {
        name: fiatAssetMeta[currency]?.name || selectedWallet.Currency?.name || currency,
        symbol: currency,
        icon: fiatAssetMeta[currency]?.icon || "https://flagcdn.com/un.svg",
        balance: selectedWallet.balance || "0.00",
        pricePrefix: fiatAssetMeta[currency]?.pricePrefix || currency + " ",
    } : {
        name: fiatAssetMeta[currency]?.name || currency,
        symbol: currency,
        icon: fiatAssetMeta[currency]?.icon || "https://flagcdn.com/un.svg",
        balance: "0.00",
        pricePrefix: fiatAssetMeta[currency]?.pricePrefix || currency + " ",
    };

        const swapTypeOptions = [
        { id: "FIAT_TO_CRYPTO", name: "Fiat to Crypto" },
        { id: "CRYPTO_TO_FIAT", name: "Crypto to Fiat" },
         { id: "FIAT_TO_FIAT", name: "Fiat to Fiat" }
    ];

    // ========== REDUX SELECTORS ==========
    const { cryptocoins = [] } = useSelector((state) => state.settings);


    // ========== REFS ==========
    const toSelectRef = useRef(null);
    const swapTypeRef = useRef(null);
    const debounceRef = useRef(null);

    // Get fiat icon helper
    const getFiatIcon = (currencyCode) => {
        const flagIcons = {
            NGN: "https://flagcdn.com/ng.svg",
            GHS: "https://flagcdn.com/gh.svg",
            USD: "https://flagcdn.com/us.svg"
        };
        return flagIcons[currencyCode] || "https://flagcdn.com/un.svg";
    };

    // Initialize fromCoin with current currency
    const [fromCoin, setFromCoin] = useState({
        name: fiatAssetMeta[currency]?.name || currency,
        symbol: currency,
        icon: fiatAssetMeta[currency]?.icon || "https://flagcdn.com/un.svg",
        balance: selectedWallet?.balance || "0.00",
        id: selectedWallet?.id
    });

       // Get available assets for swap
    const getAvailableToAssets = () => {
        if (swapType === "FIAT_TO_CRYPTO") {
            return (cryptocoins || []).map(coin => ({
                name: coin.name,
                symbol: coin.currency?.toUpperCase(),
                icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
                balance: coin.balance || "0.00",
                id: coin.coin_type_id
            }));
        } else if (swapType === "CRYPTO_TO_FIAT") {
            // CRYPTO_TO_FIAT - show all fiat wallets (no filtering)
            return walletData?.fiatWallets?.filter(wallet => wallet.is_active).map(wallet => ({
                name: wallet.Currency.name,
                symbol: wallet.Currency.code,
                icon: getFiatIcon(wallet.Currency.code),
                balance: wallet.balance || "0.00",
                id: wallet.id
            })) || [];
        } else if (swapType === "FIAT_TO_FIAT") {
            // FIAT_TO_FIAT - show other fiat currencies
            return walletData?.fiatWallets?.filter(wallet => wallet.is_active && wallet.Currency.code !== fromCoin.symbol).map(wallet => ({
                name: wallet.Currency.name,
                symbol: wallet.Currency.code,
                icon: getFiatIcon(wallet.Currency.code),
                balance: wallet.balance || "0.00",
                id: wallet.id
            })) || [];
        }
    };
// Get QuidaxUserId for the selected crypto coin
const getQuidaxUserId = useCallback(() => {
    if (swapType === "FIAT_TO_CRYPTO") {
        const toCoinData = cryptocoins.find(coin => coin.currency?.toUpperCase() === toCoin?.symbol);
        return toCoinData?.quidaxUserId || null;
    } else if (swapType === "CRYPTO_TO_FIAT") {
        const fromCoinData = cryptocoins.find(coin => coin.currency?.toUpperCase() === fromCoin.symbol);
        return fromCoinData?.quidaxUserId || null;
    }
    return null;
}, [cryptocoins, fromCoin.symbol, toCoin?.symbol, swapType]);

      // Handle swap type change
     // Handle swap type change
    const handleSwapType = (e, typeId) => {
        setOpenSwapType(false);
        setSwapTypeLabel(e.target.textContent);
        setSwapType(typeId);
        resetSelections(typeId);
    };

    const resetSelections = (newSwapType) => {
        if (newSwapType === "FIAT_TO_CRYPTO") {
            // For FIAT_TO_CRYPTO, set fromCoin to current page currency
            setFromCoin({
                name: fiatAssetMeta[currency]?.name || currency,
                symbol: currency,
                icon: fiatAssetMeta[currency]?.icon || "https://flagcdn.com/un.svg",
                balance: selectedWallet?.balance || "0.00",
                id: selectedWallet?.id
            });
            setToCoin(null);
        } else if (newSwapType === "CRYPTO_TO_FIAT") {
            // For CRYPTO_TO_FIAT, start with first available crypto
            if (cryptocoins && cryptocoins.length > 0) {
                const firstCrypto = cryptocoins[0];
                setFromCoin({
                    name: firstCrypto.name,
                    symbol: firstCrypto.currency?.toUpperCase(),
                    icon: coinIcons[firstCrypto.currency?.toUpperCase()] || bitcoinIcon,
                    balance: firstCrypto.balance || "0.00",
                    id: firstCrypto.coin_type_id
                });
            }
            setToCoin(null);
        } else if (newSwapType === "FIAT_TO_FIAT") {
            // For FIAT_TO_FIAT, set fromCoin to current page currency
            setFromCoin({
                name: fiatAssetMeta[currency]?.name || currency,
                symbol: currency,
                icon: fiatAssetMeta[currency]?.icon || "https://flagcdn.com/un.svg",
                balance: selectedWallet?.balance || "0.00",
                id: selectedWallet?.id
            });
            setToCoin(null);
        }
        
        // Reset all amount and quotation fields
        setSwapAmount("");
        setReceiveAmount("");
        setCurrentRate("");
        setQuotationError("");
        setCurrencyExchangeSettingsId(null);
        setOpenFromSelect(false);
        setOpenToSelect(false);
        
        // Clear any pending debounce timers
        if (debounceRef.current) clearTimeout(debounceRef.current);
    };


    // Handle select asset
    const handleToAssetSelect = (asset) => {
        setToCoin(asset);
        setOpenToSelect(false);
        setSwapAmount("");
        setReceiveAmount("");
        setCurrentRate("");
    };

    // Close dropdowns on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (toSelectRef.current && !toSelectRef.current.contains(event.target)) {
                setOpenToSelect(false);
            }
            if (swapTypeRef.current && !swapTypeRef.current.contains(event.target)) {
                setOpenSwapType(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // ========== HELPER FUNCTIONS ==========
    const formatType = (type) => {
        if (!type) return "";
        const t = type.toString().toLowerCase();
        if (t.includes("fiat_to_fiat") || t.includes("swap")) return "Swap";
        if (t.includes("fiat_deposit") || t.includes("deposit") || t.includes("receive")) return "Receive";
        if (t.includes("fiat_withdrawal") || t.includes("withdraw")) return "Withdraw";
        if (t.includes("crypto_to_fiat")) return "Sell";
        if (t.includes("fiat_to_crypto")) return "Buy";
        return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const getTransactionAmountAndCurrency = (tx) => {
        if (!tx || !tx.type) return `${tx?.amount || "0"} `;
        
        const txType = tx.type.toLowerCase();
        let amount = "0";
        let currency = "";
        
        if (txType === "fiat_to_crypto") {
            amount = tx.data?.amount_fiat || "0";
            currency = tx.data?.from_currency || "";
        } 
        else if (txType === "crypto_to_fiat") {
            amount = tx.data?.final_amount_received || "0";
            currency = tx.data?.from_currency || "";
        } 
        else {
            // Fallback for unknown types
            amount = tx.amount || "0";
            currency = (tx.data?.from_currency || "").toUpperCase();
        }
        
        return `${amount} ${currency}`;
    };

   // Handle swap quotation
        const handleSwapQuotation = useCallback(async (amount) => {
            if (!amount || !toCoin || !fromCoin || parseFloat(amount) <= 0) {
                setReceiveAmount("");
                setCurrentRate("");
                return;
            }

            // Handle Fiat to Fiat using exchangeConfig (no API call needed)
            if (swapType === "FIAT_TO_FIAT") {
                const exchangeRateData = exchangeConfig?.find(
                    (rate) =>
                        rate.BaseCurrency?.code === fromCoin.symbol && 
                        rate.TargetCurrency?.code === toCoin.symbol
                );

                if (exchangeRateData) {
                    const rate = parseFloat(exchangeRateData.exchange_rate);
                    const calculatedReceiveAmount = parseFloat(amount) * rate;
                    setReceiveAmount(calculatedReceiveAmount.toFixed(2));
                    setCurrencyExchangeSettingsId(exchangeRateData.id);
                    
                    // Format rate display (handle rates < 1)
                    if (rate < 1) {
                        const inverseRate = (1 / rate).toFixed(2);
                        setCurrentRate(`1 ${toCoin.symbol} = ${inverseRate} ${fromCoin.symbol}`);
                    } else {
                        setCurrentRate(`1 ${fromCoin.symbol} = ${rate.toFixed(2)} ${toCoin.symbol}`);
                    }
                    setQuotationError("");
                } else {
                    setQuotationError("Exchange rate not found for the selected currencies.");
                    setReceiveAmount("");
                    setCurrentRate("");
                    setCurrencyExchangeSettingsId(null);
                }
                return;
            }

            setIsLoadingQuotation(true);
            setQuotationError("");
            
            try {
                const quotationData = {
                    from_currency: fromCoin.symbol.toLowerCase(),
                    to_currency: toCoin.symbol.toLowerCase(),
                    from_amount: amount,
                    quidaxUserId: getQuidaxUserId(),
                    transaction_type: swapType.toLowerCase()
                };
                
                const result = await dispatch(generateSwapQuotation(quotationData));
                
                if (result.type === "generateSwapQuotation/fulfilled") {
                    const quotation = result.payload;
                    if (swapType === "FIAT_TO_CRYPTO") {
                        const rate = quotation.data?.rate;
                        const finalPayout = quotation.data?.final_payout;
                        setReceiveAmount(finalPayout);
                        setCurrentRate(`1 ${toCoin.symbol} = ${parseFloat(rate).toLocaleString(undefined, { maximumFractionDigits: 8 })} ${fromCoin.symbol}`);
                    } else if (swapType === "CRYPTO_TO_FIAT") {
                        const rate = quotation.data?.amount_usd;
                        const finalPayout = quotation.data?.final_payout;
                        setReceiveAmount(finalPayout);
                        setCurrentRate(`1 ${fromCoin.symbol} = ${parseFloat(rate).toLocaleString(undefined, { maximumFractionDigits: 8 })} USD`);
                    }
                    setQuotationError("");
                } else {
                    setQuotationError("Failed to get swap quotation");
                    setReceiveAmount("");
                    setCurrentRate("");
                }
            } catch (error) {
                console.error("Quotation error:", error);
                setQuotationError("Failed to get swap quotation");
                setReceiveAmount("");
                setCurrentRate("");
            } finally {
                setIsLoadingQuotation(false);
            }
        }, [dispatch, fromCoin, toCoin, swapType, getQuidaxUserId, exchangeConfig]);

    const debouncedQuotation = useCallback((amount) => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSwapQuotation(amount);
        }, 800);
    }, [handleSwapQuotation]);

     const handleFinalSwap = async () => {
        setIsSwapInitiated(false);
        setIsInstantSwapOpen(false);
        setIsOpen(true);
        try {
            let result;
            if (swapType === "FIAT_TO_CRYPTO") {
                const fiatToCryptoData = {
                    coinTypeId: toCoin.id,
                    debitWalletId: fromCoin.id,
                    amountFiat: swapAmount
                };
                result = await dispatch(fiatToCrypto(fiatToCryptoData));
            } else if (swapType === "CRYPTO_TO_FIAT") {
                const tradeData = {
                    coinTypeId: fromCoin.id,
                    amount: swapAmount,
                    rate: parseFloat(currentRate.split("=")[1]),
                    payoutAmount: receiveAmount,
                    creditWalletId: toCoin.id,
                    coinAmount: swapAmount,
                    sellerRemarks: ""
                };
                result = await dispatch(tradeCryptoToFiat(tradeData));
            } else if (swapType === "FIAT_TO_FIAT") {
                result = await dispatch(InitiateExchange({
                    amount: parseFloat(swapAmount),
                    currencyExchangeSettingsId: currencyExchangeSettingsId
                }));
            }
            
            if (result && (result.type?.endsWith("/fulfilled"))) {
                setIsOpen(false);
                setSuccessModal(true);
                setSwapAmount("");
                setReceiveAmount("");
                setCurrentRate("");
                setToCoin(null);
                setSwapType("FIAT_TO_CRYPTO");
                setSwapTypeLabel("Fiat to Crypto");
                setCurrencyExchangeSettingsId(null);
                dispatch(getCryptoCoins());
                dispatch(getWalletBalance());
                fetchTransactions(0, txPerPage);
            } else {
                setIsOpen(false);
                cogoToast.error("Swap failed. Please try again.");
                setSwapAmount("");
                setReceiveAmount("");
                setCurrentRate("");
                setToCoin(null);
                setSwapType("FIAT_TO_CRYPTO");
                setSwapTypeLabel("Fiat to Crypto");
                setCurrencyExchangeSettingsId(null);
            }
        } catch (error) {
            setIsOpen(false);
            cogoToast.error("Swap error: " + (error.message || "Unknown error"));
            setSwapAmount("");
            setReceiveAmount("");
            setCurrentRate("");
            setToCoin(null);
            setSwapType("FIAT_TO_CRYPTO");
            setSwapTypeLabel("Fiat to Crypto");
            setCurrencyExchangeSettingsId(null);
            console.error("Swap error:", error);
        }
    };

    // ========== TRANSACTION HANDLERS ==========
    const fetchTransactions = useCallback(
        async (pageParam = txPage, perPageParam = txPerPage) => {
            setIsLoadingTransactions(true);
            try {
                const result = await dispatch(
                    getUserCryptoTransactions({
                        coinType: currency.toLowerCase(),
                        page: pageParam,
                        per_page: perPageParam,
                        mode: 'instant',
                    })
                );
                if (result?.type === "getUserCryptoTransactions/fulfilled") {
                    const payloadData = result.payload?.data || {};
                    setTransactions(payloadData.transactions || []);
                    setTransactionsMeta(payloadData.meta || { page: pageParam, per_page: perPageParam, count: 0 });
                } else {
                    setTransactions([]);
                    setTransactionsMeta({ page: pageParam, per_page: perPageParam, count: 0 });
                }
            } catch (err) {
                setTransactions([]);
                setTransactionsMeta({ page: pageParam, per_page: perPageParam, count: 0 });
            } finally {
                setIsLoadingTransactions(false);
            }
        },
        [dispatch, currency, txPage, txPerPage]
    );

    // ========== EFFECTS ==========
    useEffect(() => {
        fetchTransactions(txPage, txPerPage);
    }, [fetchTransactions, txPage, txPerPage, currency]);

    useEffect(() => {
        dispatch(setHeader(`${selectedFiat.name} Wallet`));
        dispatch(getWalletBalance());
        dispatch(fetchExchangeConfig());
    }, [dispatch, selectedFiat.name]);

    // ========== RENDER ==========
    return (
        <>

        {/* ===== LOADING MODAL ===== */}
        <Modal canClose={false} modalOpen={isOpen} setModalOpen={setIsOpen}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
                </div>
                <div>
                    <h4 style={{ color: '#40196D', fontWeight: '600', marginTop: '25px' }}>Processing</h4>
                    <p style={{ color: '#B6B6B6', maxWidth: '300px', margin: 'auto', marginTop: '15px' }}>
                        Please wait...
                    </p>
                </div>
            </div>
        </Modal>

        {/* ===== SUCCESS MODAL ===== */}
        <Modal canClose={true} modalOpen={isSuccessModal} setModalOpen={setSuccessModal}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                    <img src={successIcon} alt="check mark circle" />
                </div>
                <div>
                    <h4 style={{ color: '#40196D', fontWeight: '600', marginTop: '25px' }}>Transaction Successful</h4>
                    <p style={{ color: '#B6B6B6', maxWidth: '300px', margin: 'auto', marginTop: '15px' }}>
                        Your swap has been successfully processed.
                    </p>
                </div>
                <button onClick={() => setSuccessModal(false)} style={{ marginTop: '20px' }} className={style.save}>
                    Continue
                </button>
            </div>
        </Modal>
          
            {/* ===== INSTANT SWAP MODAL ===== */}
        <Modal
            title="Instant Swap"
            minWidth="40%"
            canClose
            modalOpen={isInstantSwapOpen}
            setModalOpen={setIsInstantSwapOpen}
        >
            {!isSwapInitiated ? (
                <form className={style.swapForm}>
                    {/* SWAP TYPE SELECTOR */}
                    <div className={style.labelPut}>
                        <label>Swap Type</label>
                        <div className={style.select} style={{marginTop: '10px'}} ref={swapTypeRef}>
                            <div 
                                id="swapType"
                                name="swapType" 
                                className={style.selectInput}
                                onClick={() => setOpenSwapType((prev) => !prev)}
                            >
                                <input
                                    type="text"
                                    disabled={browserName === "Firefox" ? false : true}
                                    value={swapTypeLabel}
                                    placeholder="Select Swap Type"
                                    style={{pointerEvents: "none"}}
                                />
                                <ArrowDown2
                                    style={{
                                        transform: openSwapType ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                    height: openSwapType ? "fit-content" : "0px",
                                    maxHeight: 'fit-content',
                                }}
                                className={style.option}
                            >
                                {swapTypeOptions.map((option, index) => (
                                    <p
                                        id="swapTypeDrop"
                                        key={option.id}
                                        onClick={(e) => handleSwapType(e, option.id)}
                                        style={{
                                            borderBottom: `${index !== swapTypeOptions.length - 1 ? '1px #90909042 solid': ''}`,
                                            padding: '12px 16px',
                                            margin: 0
                                        }}
                                    >
                                        {option.name}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>

                   {/* FROM */}
                <div className={style.labelPut} style={{marginTop: '12px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <label>From</label>
                        <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>
                            Balance: {fromCoin.balance} {fromCoin.symbol}
                        </p>
                    </div>
                    {swapType === "CRYPTO_TO_FIAT" ? (
                        // Show crypto coins for CRYPTO_TO_FIAT
                        <div className={style.select} style={{marginTop: '10px'}}>
                            <div
                                className={style.selectInput}
                                onClick={() => setOpenFromSelect((prev) => !prev)}
                            >
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                    <img src={fromCoin.icon} alt={fromCoin.symbol} className={style.swapCoinIcon} />
                                    <span>{fromCoin.symbol}</span>
                                </div>
                                <ArrowDown2
                                    style={{
                                        transform: openFromSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                    height: openFromSelect ? "fit-content" : "0px",
                                    maxHeight: openFromSelect ? "200px" : "0px",
                                    overflowY: "auto"
                                }}
                                className={style.option}
                            >
                                {(cryptocoins || []).map((coin, index) => (
                                    <p
                                        key={coin.currency?.toUpperCase()}
                                        onClick={() => {
                                            setFromCoin({
                                                name: coin.name,
                                                symbol: coin.currency?.toUpperCase(),
                                                icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
                                                balance: coin.balance || "0.00",
                                                id: coin.coin_type_id
                                            });
                                            setOpenFromSelect(false);
                                            setSwapAmount("");
                                            setReceiveAmount("");
                                            setCurrentRate("");
                                        }}
                                        style={{
                                            borderBottom: `${index !== (cryptocoins?.length - 1) ? '1px #90909042 solid': ''}`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            padding: '12px 16px'
                                        }}
                                    >
                                        <img src={coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon} alt={coin.currency?.toUpperCase()} style={{width: '24px', height: '24px', borderRadius: '50%'}} />
                                        <span>{coin.currency?.toUpperCase()} - {coin.name}</span>
                                        <span style={{ fontSize: '12px', color: '#909090' }}>
                                            {parseFloat(coin.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {coin.currency?.toUpperCase()}
                                        </span>
                                    </p>
                                ))}
                            </div>
                        </div>
                    ) : swapType === "FIAT_TO_FIAT" ? (
                        // Show fiat wallets for FIAT_TO_FIAT
                        <div className={style.select} style={{marginTop: '10px'}}>
                            <div
                                className={style.selectInput}
                                onClick={() => setOpenFromSelect((prev) => !prev)}
                            >
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                    <img src={fromCoin.icon} alt={fromCoin.symbol} className={style.swapCoinIcon} />
                                    <span>{fromCoin.symbol}</span>
                                </div>
                                <ArrowDown2
                                    style={{
                                        transform: openFromSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                    height: openFromSelect ? "fit-content" : "0px",
                                    maxHeight: openFromSelect ? "200px" : "0px",
                                    overflowY: "auto"
                                }}
                                className={style.option}
                            >
                                {walletData?.fiatWallets?.filter(wallet => wallet.is_active).map((wallet, index) => (
                                    <p
                                        key={wallet.id}
                                        onClick={() => {
                                            setFromCoin({
                                                name: wallet.Currency.name,
                                                symbol: wallet.Currency.code,
                                                icon: getFiatIcon(wallet.Currency.code),
                                                balance: wallet.balance || "0.00",
                                                id: wallet.id
                                            });
                                            setOpenFromSelect(false);
                                            setSwapAmount("");
                                            setReceiveAmount("");
                                            setCurrentRate("");
                                        }}
                                        style={{
                                            borderBottom: `${index !== (walletData?.fiatWallets?.length - 1) ? '1px #90909042 solid': ''}`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            padding: '12px 16px'
                                        }}
                                    >
                                        <img src={getFiatIcon(wallet.Currency.code)} alt={wallet.Currency.code} style={{width: '24px', height: '24px', borderRadius: '50%'}} />
                                        <span>{wallet.Currency.code} - {wallet.Currency.name}</span>
                                        <span style={{ fontSize: '12px', color: '#909090' }}>
                                            {parseFloat(wallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {wallet.Currency.code}
                                        </span>
                                    </p>
                                ))}
                            </div>
                        </div>
                    ) : (
                        // FIAT_TO_CRYPTO - show fiat wallets (exclude USD)
                        <div className={style.select} style={{marginTop: '10px'}}>
                            <div
                                className={style.selectInput}
                                onClick={() => setOpenFromSelect((prev) => !prev)}
                            >
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                    <img src={fromCoin.icon} alt={fromCoin.symbol} className={style.swapCoinIcon} />
                                    <span>{fromCoin.symbol}</span>
                                </div>
                                <ArrowDown2
                                    style={{
                                        transform: openFromSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                    height: openFromSelect ? "fit-content" : "0px",
                                    maxHeight: openFromSelect ? "200px" : "0px",
                                    overflowY: "auto"
                                }}
                                className={style.option}
                            >
                            {walletData?.fiatWallets?.filter(wallet => {
                                    if (swapType === "FIAT_TO_CRYPTO") {
                                        return wallet.is_active && wallet.Currency.code !== "USD";
                                    }
                                    return wallet.is_active;
                                }).map((wallet, index) => (
                                    <p
                                        key={wallet.id}
                                        onClick={() => {
                                            setFromCoin({
                                                name: wallet.Currency.name,
                                                symbol: wallet.Currency.code,
                                                icon: getFiatIcon(wallet.Currency.code),
                                                balance: wallet.balance || "0.00",
                                                id: wallet.id
                                            });
                                            setOpenFromSelect(false);
                                            setSwapAmount("");
                                            setReceiveAmount("");
                                            setCurrentRate("");
                                        }}
                                        style={{
                                            borderBottom: `${index !== (walletData?.fiatWallets?.length - 1) ? '1px #90909042 solid': ''}`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            padding: '12px 16px'
                                        }}
                                    >
                                        <img src={getFiatIcon(wallet.Currency.code)} alt={wallet.Currency.code} style={{width: '24px', height: '24px', borderRadius: '50%'}} />
                                        <span>{wallet.Currency.code} - {wallet.Currency.name}</span>
                                        <span style={{ fontSize: '12px', color: '#909090' }}>
                                            {parseFloat(wallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {wallet.Currency.code}
                                        </span>
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

               {/* AMOUNT */}
            <div className={style.labelPut} style={{marginTop: '10px'}}>
                <label>Amount<span style={{ color: "#FF0000" }}>*</span></label>
                <div className={style.input} style={{position: 'relative', marginTop: '10px'}}>
                    <input
                        type="number"
                        name="swapAmount"
                        placeholder="Enter Swap Amount"
                        value={swapAmount}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSwapAmount(value);
                            setReceiveAmount("");
                            setCurrentRate("");
                            if (toCoin && value && parseFloat(value) > 0) {
                                debouncedQuotation(value);
                            }
                        }}
                    />
                </div>
            </div>

                    {/* TO */}
                    <div className={style.labelPut} style={{marginTop: '10px'}}>
                        <label>To</label>
                        <div className={style.select} style={{marginTop: '10px'}} ref={toSelectRef}>
                            <div 
                                id="toSelect"
                                className={style.selectInput}
                                onClick={() => setOpenToSelect((prev) => !prev)}
                            >
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                    {toCoin ? (
                                        <>
                                            <img src={toCoin.icon} alt={toCoin.symbol} className={style.swapCoinIcon} />
                                            <span>{toCoin.symbol}</span>
                                        </>
                                    ) : (
                                        <span style={{color: '#909090'}}>
                                            Select {swapType === "FIAT_TO_CRYPTO" ? "Crypto" : "Fiat"}
                                        </span>
                                    )}
                                </div>
                                <ArrowDown2
                                    style={{
                                        transform: openToSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                        pointerEvents: "none",
                                    }}
                                    className={style.dropDown}
                                    size="20"
                                    color="#909090"
                                    variant="Bold"
                                />
                            </div>
                            <div
                                style={{
                                    height: openToSelect ? "fit-content" : "0px",
                                    maxHeight: openToSelect ? "200px" : "0px",
                                    overflowY: "auto"
                                }}
                                className={style.option}
                            >
                                {getAvailableToAssets().length > 0 ? (
                                    getAvailableToAssets().map((asset, index) => (
                                        <p
                                            id="toSelectDrop"
                                            key={asset.symbol}
                                            onClick={() => handleToAssetSelect(asset)}
                                            style={{
                                                borderBottom: `${index !== getAvailableToAssets().length - 1 ? '1px #90909042 solid': ''}`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                gap: '10px',
                                                padding: '12px 16px'
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <img src={asset.icon} alt={asset.symbol} style={{width: '24px', height: '24px', borderRadius: '50%'}} />
                                                <span>{asset.symbol} - {asset.name}</span>
                                            </div>
                                            <span style={{ fontSize: '12px', color: '#909090' }}>
                                                {parseFloat(asset.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {asset.symbol}
                                            </span>
                                        </p>
                                    ))
                                ) : (
                                    <p style={{ padding: '12px 16px', color: '#FF0000' }}>
                                        {swapType === "FIAT_TO_CRYPTO" ? "No available cryptocurrencies." : "No fiat wallets available."}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Rate Info */}
                    <div className={style.swapRateInfo}>
                        <img src={info_icon} alt="info" style={{ width: 18, height: 18, marginRight: 6 }} />
                        {isLoadingQuotation ? (
                            "Getting current rate..."
                        ) : quotationError ? (
                            <span style={{ color: '#F40000' }}>{quotationError}</span>
                        ) : currentRate ? (
                            currentRate
                        ) : (
                            "Enter amount to see rate"
                        )}
                    </div>

                    {/* You Receive */}
                    <div className={style.labelPut}>
                        <label>You Receive</label>
                        <div className={style.input} style={{marginTop: '10px'}}>
                            <input
                                type="text"
                                name="receiveAmount"
                                placeholder="Amount"
                                value={receiveAmount ? Number(receiveAmount).toLocaleString(undefined, { maximumFractionDigits: 8 }) : ""}
                                disabled
                            />
                        </div>
                    </div>

                    {/* Disclaimer */}
                    <div className={style.swapDisclaimer}>
                        Swapping may be subject to changing rates.<br />
                        Values displayed are only estimates of current market price.
                    </div>

                    {/* Swap Button */}
                    <button
                        className={style.swapBtn}
                        type="button"
                        disabled={!swapAmount || !toCoin || isLoadingQuotation || !receiveAmount}
                        onClick={() => setIsSwapInitiated(true)}
                    >
                        {isLoadingQuotation ? "Getting Rate..." : "Swap"}
                    </button>
                </form>
            ) : (
                /* Confirmation Step */
                <div style={{ marginTop: '20px' }}>
                    <div
                        onClick={() => setIsSwapInitiated(false)}
                        style={{
                            width: '20px',
                            height: '20px',
                            background: '#40196d1a',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        <img src={arrow_left} alt="arrow left" />
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
                        <img src={fromCoin.icon} alt={fromCoin.symbol} style={{ width: 64, height: 64, borderRadius: "50%", zIndex: 2 }} />
                        <img src={toCoin.icon} alt={toCoin.symbol} style={{ width: 64, height: 64, borderRadius: "50%", marginLeft: -20, zIndex: 1 }} />
                    </div>

                    <div className={style.confirmSwapBox} style={{
                        background: '#F5F3F7',
                        marginTop: '20px',
                        borderRadius: '20px',
                        padding: '25px 25px'
                    }}>
                        <p style={{ color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0 }}>
                            Please check transaction details
                        </p>

                        <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                            <div><img src={fromCoin.icon} alt={fromCoin.name} width={24} height={24} /></div>
                            <div>
                                <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Swap From</h6>
                                <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                    {fromCoin.name}
                                </p>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                            <div><img src={toCoin.icon} alt={toCoin.name} width={24} height={24} /></div>
                            <div>
                                <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>To</h6>
                                <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                    {toCoin.name}
                                </p>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                            <div><img src={info_icon} alt='amountIcon' /></div>
                            <div>
                                <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Swap Amount</h6>
                                <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                    {swapAmount} {fromCoin.symbol}
                                </p>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                            <div><img src={info_icon} alt='moneyIcon' /></div>
                            <div>
                                <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>You Receive</h6>
                                <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                    {receiveAmount ? Number(receiveAmount).toLocaleString(undefined, { maximumFractionDigits: 8 }) : "0"} {toCoin.symbol}
                                </p>
                            </div>
                        </div>
                    </div>

               <button className={style.swapBtn} style={{ marginTop: 24 }} onClick={handleFinalSwap}>
                    Proceed
                </button>
                </div>
            )}
        </Modal>


        
            {/* ===== MAIN PAGE CONTENT ===== */}
            {/* Top Section - Side by Side */}
            <div className={style.cryptoWalletTopSection}>
                {/* Wallet Balance Card */}
                <div className={style.cryptoBalanceCard}>
                    <div className={style.cryptoBalanceLeft}>
                        <div className={style.cryptoBalanceLabel}>WALLET BALANCE</div>
                        <div className={style.cryptoBalanceAmount}>
                            {visible === true
                                ? `${selectedFiat.pricePrefix}${parseFloat(selectedFiat.balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                : '********'}
                            {visible === true ? (
                                <EyeSlash onClick={() => setVisible(!visible)} className={style.walEye} color="#40196D" variant="Bulk" style={{ cursor: 'pointer' }} />
                            ) : (
                                <Eye onClick={() => setVisible(!visible)} className={style.walEye} color="#40196D" variant="Bulk" style={{ cursor: 'pointer' }} />
                            )}
                        </div>
                    </div>
                    <div className={style.cryptoBalanceRight}>
                        <div className={style.cryptoCoinBadge}>
                            <img src={selectedFiat.icon} alt={selectedFiat.symbol} className={style.cryptoCoinIcon} />
                            <span className={style.cryptoCoinSymbol}>{selectedFiat.name}</span>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className={style.cryptoWalletActions}>
                    <div className={style.cryptoWalletAction} onClick={() => setIsInstantSwapOpen(true)}>
                        <div className={style.cryptoActionIconWrap}>
                            <img src={swapIcon} alt="Swap" style={{ width: '24px', height: '24px' }} />
                        </div>
                        <span>Swap</span>
                    </div>
                    <div className={style.cryptoWalletAction} onClick={() => navigate(`/withdraw-with-fiat?currency=${currency}`)}>
                        <div className={style.cryptoActionIconWrap}>
                            <img src={withdrawIcon} alt="withdrawIcon" style={{ width: '24px', height: '24px' }} />
                        </div>
                        <span>Withdraw</span>
                    </div>
                   {currency === "NGN" && (
                        <div className={style.cryptoWalletAction} onClick={() => navigate(`/deposit-with-fiat?currency=${currency}`)}>
                            <div className={style.cryptoActionIconWrap}>
                                <img src={receiveIcon} alt="receiveIcon" style={{ width: '24px', height: '24px' }} />
                            </div>
                            <span>Deposit</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Recent Transactions */}
            <div className={style.recentTransactionsTitle}>Recent Transactions</div>

            <section className={style.transactionsSection}>
                <div className={style.transactionsHeader}>
                    <div>
                        <label style={{ marginRight: 8 }}>Per page</label>
                        <select value={txPerPage} onChange={e => { setTxPerPage(Number(e.target.value)); setTxPage(0); }}>
                            <option value={15}>15</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                </div>

                <div className={style.table}>
                    <table>
                        <thead>
                            <tr>
                                <th><div className={style.tableHead}><h5>Transaction</h5></div></th>
                                <th><div className={style.tableHead}><h5>Date</h5></div></th>
                                <th><div className={style.tableHead}><h5>Hash ID</h5></div></th>
                                <th><div className={style.tableHead}><h5>Amount</h5></div></th>
                                <th><div className={style.tableHead}><h5>Status</h5></div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoadingTransactions ? (
                                <tr><td colSpan="5">Loading...</td></tr>
                            ) : transactions.length === 0 ? (
                                <tr><td colSpan="5">No transactions</td></tr>
                            ) : (
                                transactions.map((tx) => {
                                    const iconSrc = tx.type && tx.type.toLowerCase().includes("withdraw")
                                        ? withdrawIcon
                                        : tx.type && tx.type.toLowerCase().includes("deposit")
                                            ? receiveIcon
                                            : swapIcon;
                                    const fromCurrency = (tx.data?.from_currency || "").toUpperCase();
                                    const toCurrency = (tx.data?.to_currency || "").toUpperCase();
                                    const displayRef = tx.data?.txid || 'N/A';
                                    return (
                                        <tr key={tx.id} className={style.fullRow}>
                                            <td className={style.user}>
                                                <div className={style.tableHead}>
                                                    <div className={style.image} style={{ flexShrink: 0, borderRadius: '0%' }}>
                                                        <img src={iconSrc} alt={tx.type} />
                                                    </div>
                                                    <div className={style.name}>
                                                        <h6>{formatType(tx.type)}</h6>
                                                        <p>
                                                            {(tx.type === "fiat_to_fiat" || tx.type === "fiat_to_crypto")
                                                                ? `${fromCurrency} to ${toCurrency}`
                                                                : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className={style.date}>
                                                    <h6>{tx.created_at ? moment(tx.created_at).format("MMM D, YYYY") : "-"}</h6>
                                                    <p>at {tx.created_at ? moment(tx.created_at).format("hh:mm A") : "-"}</p>
                                                </div>
                                            </td>
                                           <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <p className={style.invoice}>
                                                    {displayRef?.substring(0, 25)}
                                                </p>
                                                {displayRef && displayRef !== "N/A" && (
                                                    <button
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(displayRef);
                                                            cogoToast.success("Hash ID copied to clipboard", { position: 'top-right' });
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: '4px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            flexShrink: 0,
                                                            color: '#40196D'
                                                        }}
                                                        title="Copy"
                                                    >
                                                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                                            <path d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                            <td>
                                                <p className={style.amount} style={{ textAlign: 'left' }}>
                                                         {getTransactionAmountAndCurrency(tx)}
                                                </p>
                                            </td>
                                            <td>
                                                <div className={
                                                    `${tx.status.toLowerCase() === "completed" ? style.success :
                                                      tx.status.toLowerCase() === "pending" || tx.status.toLowerCase() === 'pending_admin' ? style.pending :
                                                      tx.status.toLowerCase() === "failed" ? style.error :
                                                      style.pending
                                                    }`
                                                }>
                                                    {tx.status.replace(/_/g, " ")}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>

                    {/* Mobile View */}
                    <div className={style.transList}>
                        {transactions.map((tx) => {
                            const iconSrc = tx.type && tx.type.toLowerCase().includes("withdraw")
                                ? withdrawIcon
                                : tx.type && tx.type.toLowerCase().includes("deposit")
                                    ? receiveIcon
                                    : swapIcon;
                            const fromCurrency = (tx.data?.from_currency || "").toUpperCase();
                            const toCurrency = (tx.data?.to_currency || "").toUpperCase();
                            const displayRef = tx.data?.confirmation_id || tx.quidax_user_id || tx.id;
                            return (
                                <div className={style.eachTrans} key={tx.id}>
                                    <div className={style.et}>
                                        <div className={style.etPic} style={{ flexShrink: 0 }}>
                                            <img src={iconSrc} alt={tx.type} />
                                        </div>
                                        <div className={style.etTitle}>
                                            <h4>{formatType(tx.type)}</h4>
                                            <p>{(tx.type === "fiat_to_fiat" || tx.type === "fiat_to_crypto") ? `${fromCurrency} to ${toCurrency}` : toCurrency || fromCurrency}</p>
                                        </div>
                                        <div className={style.etTime}>
                                            <p>{getTransactionAmountAndCurrency(tx)}</p>
                                            <span>{tx.created_at ? moment(tx.created_at).format("MMM D") : ""}</span>
                                        </div>
                                    </div>
                                    <div className={style.etDet}>
                                        <p>Ref ID: {displayRef}</p>
                                        <div 
                                            className={`${tx.status.toLowerCase() === "completed" ? style.success :
                                              tx.status.toLowerCase() === "pending" || tx.status.toLowerCase() === 'pending_admin' ? style.pending :
                                              tx.status.toLowerCase() === "failed" ? style.error :
                                              style.pending
                                            }`
                                        }
                                        >{tx.status}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className={style.txPagination} style={{ display: "flex", justifyContent: "space-between", marginTop: 12, paddingBottom: 24 }}>
                    <div>
                        <button disabled={txPage <= 0} onClick={() => setTxPage(p => Math.max(0, p - 1))}>Prev</button>
                        <button
                            disabled={(transactionsMeta.count || 0) <= (txPage + 1) * txPerPage}
                            onClick={() => setTxPage(p => p + 1)}
                            style={{ marginLeft: 8 }}
                        >
                            Next
                        </button>
                    </div>
                    <div>
                        Page {transactionsMeta.page ?? txPage} — {transactionsMeta.count ?? transactions.length} total
                    </div>
                </div>
            </section>
        </>
    );
}

export default FiatWalletPage;